module.exports = __webpack_public_path__ + "img/SDG-06-EN.9557be9c.png";